import React from 'react';
import styled from 'styled-components';
import VideoSource from '../img/PDVideo.mp4';
import { colours } from '../Styles';

const BackgroundVideo = (props) => {
    const {transpDark} = colours;
    const VideoBG = styled.div`
    position: relative;
    .overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        background: ${transpDark};
        display: flex;
        align-items: center;
        justify-content: center;
    }
    video {
        z-index: -1;
    }

    `;
    return (
        <VideoBG>
            <div className="overlay">
            {props.children}
            </div>
                <video autoPlay="autoplay" loop="loop" muted>
                    <source src={VideoSource} type="video/mp4" />
                    not supported
                </video>
        </VideoBG>
    )
}

export default BackgroundVideo;